module.exports = __webpack_public_path__ + "static/img/sm_19.58f482d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/sm_19.png
// module id = zYGD
// module chunks = 0